import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";

// css
import styles from "./addForm.module.scss";
import { Formik } from "formik";
import AppInputField from "components/shared/FormComponents/AppInputField";
import { cloneDeep } from "lodash";
import { Link, useNavigate, useParams } from "react-router-dom";
import { successMessageToast } from "helpers/common";
import { MANAGE_USERS_LIST } from "config/paths";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { RequiredFieldAstrick } from "components/Common/Common";
import addSubAdminSchema from "./addSubAdmin.schema";
import { useCreateSubAdminMutation, useGetUserDetailsQuery, useUpdateSubAdminMutation } from "store/services/users/role";
import { MIME_TYPES } from "config/constants";
import AppProfilePictureField from "components/shared/FormComponents/AppProfilePictureField";
import AppFileUploadField from "components/shared/FormComponents/AppFileUploadField";
import Switch from "react-switch";


const AddSubAdmin = () => {

  const { id: userId } = useParams();
  const navigate = useNavigate();
  const editMode = !!userId;

  // Get user details
  const { data: userDetails, isLoading } = useGetUserDetailsQuery(userId, { skip: !editMode });

  const [checked, setChecked] = useState(true);
  const [initialValues, setInitialValues] = useState({
    firstname: "",
    lastname: "",
    phone: "",
    email: "",
    password: "",
    calendly_link: "",
    self_description: "",
    profile_picture: "",
    email_signature: "",
    signature_img: "",
  })

  const [createSubAdmin, { isLoading: createSubAdminLoading }] = useCreateSubAdminMutation();
  const [updateSubAdmin, { isLoading: updateSubAdminLoading }] = useUpdateSubAdminMutation();

  const handleSubmit = async (payload) => {

    try {

      let values = cloneDeep(payload);
      values.email = values?.email?.toLowerCase();
      values.send_notification = checked ? "yes" : "no";

      const result = editMode ? await updateSubAdmin({ id: userId, data: values }) : await createSubAdmin(values);
      if (result?.error) {

        console.error("Error create sub admin", result.error);
        return;
      };

      successMessageToast(result?.data?.message);
      navigate(MANAGE_USERS_LIST);

    } catch (err) { console.error("Error create teacher", err); }
  };

  useEffect(() => {

    if (!userId) return;

    if (userDetails) {
      const { firstname = "", lastname = "", phone = "", email = "", therapist_detail = {} } = userDetails || {};
      const { calendly_link = "", self_description = "", profile_picture = "", email_signature = "", signature_img = "" } = therapist_detail || {};
      setInitialValues({ firstname, lastname, phone, email, password: "", calendly_link, self_description, profile_picture, email_signature, signature_img })
    };
  }, [userDetails]);

  return (
    <>
      <section className={`${styles.addForm} position-relative py-4 addForm`}>
        <Container fluid={true}>
          {isLoading ? <LoadingIndicator inline /> : <Row>
            <Col lg="12" className="my-2">
              <div className="TableFilter d-flex align-items-center justify-content-between gap-10 flex-wrap">
                <div className="left">
                  <div className="pageHead pb-3 d-flex align-items-center">
                    <Link
                      className="themeBlue fw-sbold back-to-btn"
                      to={MANAGE_USERS_LIST}
                    >
                      <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 12L0 6L6 0L7.425 1.4L2.825 6L7.425 10.6L6 12ZM18 14V10C18 9.16667 17.7083 8.45833 17.125 7.875C16.5417 7.29167 15.8333 7 15 7H8.825L12.425 10.6L11 12L5 6L11 0L12.425 1.4L8.825 5H15C16.3833 5 17.5625 5.4875 18.5375 6.4625C19.5125 7.4375 20 8.61667 20 10V14H18Z" fill="#1C1B1F" />
                      </svg> Back
                    </Link>
                    <h6 className="m-0 fw-bold themeBlue"> {editMode ? "Edit" : "Add"} Admin User</h6>
                  </div>
                </div>
                <div className="right">
                  <li className="d-flex align-items-center gap-10 px-2">
                    <label
                      htmlFor=""
                      className="form-label themeBlue fw-bold mb-0"
                    >
                      Send Notification
                    </label>
                    <div className=" d-flex align-items-center">
                      <p className="m-0 text-muted mx-1">Off</p>
                      <Switch
                        uncheckedIcon={""}
                        checkedIcon={""}
                        onHandleColor={"#A3DF00"}
                        offHandleColor={"#A3DF00"}
                        onColor={"#E6E6E6"}
                        offColor={"#E6E6E6"}
                        height={18}
                        width={40}
                        onChange={(checked) => setChecked(checked)}
                        checked={checked}
                      />
                      <p className="m-0 text-muted mx-1">On</p>
                    </div>
                  </li>
                </div>
              </div>
            </Col>
            <Col lg="12" className="my-2">

              <Formik
                initialValues={initialValues}
                validationSchema={addSubAdminSchema}
                onSubmit={handleSubmit}
                enableReinitialize
              >
                {({
                  handleSubmit,
                  values
                }) => (
                  <Form onSubmit={handleSubmit}>
                    <div
                      className="py-3"
                      style={{ borderTop: "1px solid #41a2a84d" }}
                    >
                      <Row>
                        <Col sm="6" md="3" className="my-2">
                          <label
                            htmlFor=""
                            className="form-label themeBlue fw-bold mb-0 d-flex"
                          >
                            Profile Picture
                          </label>
                          <AppProfilePictureField
                            name="profile_picture"
                            acl={"public-read"}
                            accept="image/*"
                            allowedTypes={[MIME_TYPES.jpeg, MIME_TYPES.jpg, MIME_TYPES.png]}
                          />
                        </Col>
                        <Col sm="6" md="3" className="my-2">
                          <label
                            htmlFor=""
                            className="form-label themeBlue fw-bold mb-0 d-flex"
                          >
                            Email
                            <RequiredFieldAstrick />
                          </label>
                          <AppInputField
                            type="text"
                            name="email"
                            placeholder="e.g abc@example.com"
                            className={`${styles.formControl} form-control`}
                          />
                        </Col>
                        <Col sm="6" md="3" className="my-2">
                          <label
                            htmlFor=""
                            className="form-label themeBlue fw-bold mb-0 d-flex"
                          >
                            Password
                          </label>
                          <AppInputField
                            autoComplete='off'
                            name="password"
                            type="password"
                            placeholder="Enter Password"
                            className={`${styles.formControl} form-control`}
                          />
                        </Col>
                        <Col sm="6" md="3" className="my-2">
                          <label
                            htmlFor=""
                            className="form-label themeBlue fw-bold mb-0 d-flex"
                          >
                            Phone
                            <RequiredFieldAstrick />
                          </label>
                          <AppInputField
                            type="text"
                            name="phone"
                            placeholder="e.g +1 23234545"
                            className={`${styles.formControl} form-control`}
                            maxLength={25}
                          />
                        </Col>
                        <Col sm="6" md="3" className="my-2">
                          <label
                            htmlFor=""
                            className="form-label themeBlue fw-bold mb-0 d-flex"
                          >
                            Last Name
                            <RequiredFieldAstrick />
                          </label>
                          <AppInputField
                            type="text"
                            name="lastname"
                            placeholder="e.g Smith"
                            className={`${styles.formControl} form-control`}
                            maxLength={30}
                          />
                        </Col>
                        <Col sm="6" md="3" className="my-2">
                          <label
                            htmlFor=""
                            className="form-label themeBlue fw-bold mb-0 d-flex"
                          >
                            First Name
                            <RequiredFieldAstrick />
                          </label>
                          <AppInputField
                            type="text"
                            name="firstname"
                            placeholder="e.g John"
                            className={`${styles.formControl} form-control`}
                            maxLength={30}
                          />
                        </Col>
                        <Col sm="6" md="6" className="my-2">
                          <label
                            htmlFor=""
                            className="form-label themeBlue fw-bold mb-0 d-flex"
                          >
                            Calendly link
                          </label>
                          <AppInputField
                            name="calendly_link"
                            placeholder="Enter Calendly link here "
                            className={`${styles.formControl} form-control`}
                          />
                        </Col>
                        <Col sm="6" md="6" className="my-2">
                          <label
                            htmlFor=""
                            className="form-label themeBlue fw-bold mb-0 d-flex"
                          >
                            About{" "}
                            <p className="text-muted fw-normal inline-block ms-1 m-0">
                              (Description)
                            </p>
                          </label>
                          <AppInputField
                            name="self_description"
                            placeholder="About (Description)"
                            fieldType="textarea"
                            rows="4"
                            className={`${styles.formControl} form-control`}
                            maxLength={500}
                            style={{ height: "100px" }}
                          />
                        </Col>
                        <Col sm="6" md="6" className="my-2">
                          <label
                            htmlFor=""
                            className="form-label themeBlue fw-bold mb-0 d-flex"
                          >
                            Email Signature
                          </label>
                          <AppInputField
                            fieldType="textarea"
                            name="email_signature"
                            rows={4}
                            cols={4}
                            placeholder="John Doe&#10;john@example.com&#10;+1 222 222 2222&#10;Street 10, NY, USA "
                            className={`${styles.formControl} form-control`}
                            maxLength={500}
                            style={{ height: "100px" }}
                          />
                        </Col>
                        <Col sm="6" md="6" className="my-2">
                          <label
                            htmlFor=""
                            className="form-label themeBlue fw-bold mb-0 d-flex"
                          >
                            Upload Signature
                          </label>
                          <AppFileUploadField
                            name="signature_img"
                            acl={"public-read"}
                            accept="image/png"
                            allowedTypes={[MIME_TYPES.png]}
                            className={`${styles.formControl} form-control`}
                            preview
                          />
                        </Col>
                        <Col className="mt-4 my-2" lg="12">
                          <div
                            className={`${styles.btnWrpper} btnWrpper d-flex align-items-center gap-10 pt-3`}
                            style={{ borderTop: "1px solid #41a2a84d" }}
                          >
                            <Button
                              disabled={createSubAdminLoading || updateSubAdminLoading}
                              type="submit"
                              className="d-flex align-items-center justify-content-center commonBtn"
                            >
                              {createSubAdminLoading || updateSubAdminLoading ? <LoadingIndicator inline /> : "Save"}

                            </Button>
                            <Button
                              type="button"
                              className="d-flex align-items-center justify-content-center commonBtn borderedBtn bg-transparent"
                              onClick={() => navigate(MANAGE_USERS_LIST)}
                            >
                              Cancel
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </Form>
                )}
              </Formik>
            </Col>
          </Row>}
        </Container>
      </section>
    </>
  );
};

export default AddSubAdmin;
